<template>
  <b-modal :active="active" has-modal-card :on-cancel="close">
    <div class="edit-profile modal-content">
      <div class="box">
        <header class="title is-5">Edit Profile</header>
        <form
          class="edit-profile__form"
          @submit.prevent="doProfileUpdateHandler"
        >
          <b-field>
            <b-input
              v-model="email"
              disabled
              icon="at"
              placeholder="Email"
              required
              type="email"
            />
          </b-field>

          <b-field>
            <b-input
              v-model="displayName"
              icon="account"
              placeholder="Name"
              required
              type="text"
            />
          </b-field>
          <b-button
            class="is-fullwidth"
            :loading="loading"
            native-type="submit"
            type="is-primary"
          >
            Update
          </b-button>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import con from '../../store/mutationTypes';

export default {
  data: function() {
    return {
      email: '',
      displayName: ''
    };
  },
  computed: {
    ...mapState({
      active: state => state.app.isEditingProfile,
      loading: state => state.auth.loading,
      user: state => state.auth.user
    })
  },
  methods: {
    ...mapActions('auth', ['doProfileUpdate']),
    close() {
      this.$store.commit(con.UPDATE_APP_STATE_NAMESPACED, {
        isEditingProfile: false
      });
    },
    async doProfileUpdateHandler() {
      try {
        await this.doProfileUpdate({
          email: this.email,
          displayName: this.displayName
        });

        this.close();
        this.$buefy.toast.open({
          message: 'Profile updated successfully!',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update profile!',
          type: 'is-danger'
        });
      }
    }
  },
  mounted() {
    this.$store.watch(
      state => state.auth.user,
      newValue => {
        this.email = newValue.email;
        this.displayName = newValue.displayName || '';
      }
    );
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.edit-profile {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
